import * as Yup from 'yup'

export const schemaSelectedLeads = (t: (key: string) => string) => ({
  selectedLeads: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required(t('requiredMessage')),
        email: Yup.string().required(t('requiredMessage')),
        phone: Yup.string().required(t('requiredMessage')),
      }),
    )
    .min(1, t('conversationNewSearchLeadsRequiredMessage')),
})
